import { CreatorSelectData } from './interfaces';

export const defaultOption: CreatorSelectData = {
  label: 'All',
  value: 'all',
};
